export const reviewsSentimentHistory = (state) => state.reviewsSentimentHistory.history || []
export const reviewsRatingHistory = (state) => state.reviewsRatingHistory.history || []
